import { apiFetch } from './client';

export type SourceKind =
  | 'book'
  | 'paper'
  | 'lecture'
  | 'transcript'
  | 'url'
  | 'note'
  | 'other';

export interface SourceSummary {
  slug: string;
  kind: SourceKind;
  title: string;
  authors: string[];
  canonical_ref: string | null;
  edition: string | null;
  source_url: string | null;
  added_ms: number;
  added_by_actor: string;
  approved_at_ms: number | null;
  archived: boolean;
  best_effort: boolean;
  replaces: string | null;
  citation_count: number;
}

export interface SourceDetail extends SourceSummary {
  text_length: number;
  text_preview: string;
  text_truncated: boolean;
}

export interface SourceListResponse {
  count: number;
  sources: SourceSummary[];
}

export function fetchSources(opts: {
  kind?: SourceKind;
  author?: string;
  archived?: 'true' | 'false' | 'all';
} = {}): Promise<SourceListResponse> {
  const params = new URLSearchParams();
  if (opts.kind) params.set('kind', opts.kind);
  if (opts.author) params.set('author', opts.author);
  if (opts.archived) params.set('archived', opts.archived);
  const qs = params.toString();
  return apiFetch<SourceListResponse>(
    `/api/sources${qs ? `?${qs}` : ''}`,
  );
}

export function fetchSource(slug: string): Promise<SourceDetail> {
  return apiFetch<SourceDetail>(`/api/sources/${slug}`);
}

export interface CitingPage {
  page_id: string;
  citation_count: number;
  last_seen_ms: number;
}

export interface CitingPagesResponse {
  slug: string;
  count: number;
  citing_pages: CitingPage[];
}

export function fetchCitingPages(slug: string): Promise<CitingPagesResponse> {
  return apiFetch<CitingPagesResponse>(
    `/api/sources/${slug}/citing-pages`,
  );
}
